<template>
    <div v-if="loading == false">
        <ChirpReport
            :data_source="rows"
            :column_meta="headers"
            :preFormattedData="true"
            :target_page="targetPage"
            :loadingColumns="loadingTable"
            ignoreDateConversion
            :totalCount="totalCount"
            :storeKey="storeKey"
            :useOverride="useOverride"
            :hide_speed_date="false"
            @cancelOverride="useOverride = false"
        />
    </div>
</template>
<script>
    import { tryGetFilter } from '@/util/tryGetFilter';
    const api_root = 'reports'
    const report = 'full_financial'
    import ChirpReport from '@/components/general/list/ChirpReport';
    import dayjs from '@/util/dayjs';
    export default {
        name: 'FullFinancialView',
        components: { ChirpReport },
        props: {
            overrideFilter: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                rows: [],
                headers: [
                    { field: 'client', headerText: 'Client', allowSorting: true, width:200 },
                    { field: 'date', headerText: 'Date', allowSorting: true},
                    { field: 'event', headerText: 'Event', allowSorting: true },
                    { field: 'invoice_num', headerText: 'Invoice #', allowSorting: true },
                    { field: 'claim_num', headerText: 'Claim #', allowSorting: true },
                    { field: 'service_fee', headerText: 'Service Fee', allowSorting: false },
                    { field: 'payment_method', headerText: 'Payment Method', allowSorting: true },
                    { field: 'check_no', headerText: 'Check #', allowSorting: true },
                    { field: 'description', headerText: 'Details', allowSorting: true },
                    { field: 'amount', headerText: 'Amount', allowSorting: true, align: 'Right' },
                ],
                targetPage: '',
                useOverride: false,
                totalCount: 0,
                loading: true,
                loadingTable: false,
                criteriaProps: {},
            }
        },
        computed: {
            criteria() {
                return this.useOverride && this.overrideFilter ? this.overrideCriteria : this.savedCriteria;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            storeKey() {
                return this.pageMeta?.page || 'dailyTransactions';
            },
        },
        methods: {
            async load_data(criteria = this.criteria) {
                const body = {
                    criteria: {
                        ...criteria,
                        report,
                    },
                };
                const res = await this.$api.post(`/${api_root}`, body);
                this.rows = res.data.rows.map((row) => ({
                    client: row.client || '--',
                    date: row.date ? dayjs(row.date).format('MM/DD/YYYY h:mma') : '--',
                    event: row.event,
                    invoice_num: row.invoice_num,
                    claim_num: row.claim_num,
                    service_fee: row.service_fee ? this.$getCurrency(row.service_fee) : '--',
                    payment_method: row.payment_method ? row.payment_method.toTitleCase() : '--',
                    check_no: row.check_no || '--',
                    description: row.description || '--',
                    amount: row.amount ? this.$getCurrency(row.amount) : '--',
                }))
                this.totalCount = res.data.total_count;

                if (
                    !criteria?.default_date_range ||
                    criteria?.default_date_range !== res.data.default_date_range
                ) {
                    this.$store.commit('filters/updateFilter', {
                        stateKey: this.storeKey,
                        criteria: {
                            ...criteria,
                            default_date_range: res.data.default_date_range,
                        },
                    });
                }

                this.$nextTick(() => {
                    this.loading = false;
                });
            },
            async init() {
                if (this.overrideFilter) {
                    this.useOverride = true;
                    this.$store.commit('filters/applyOverride', {
                        stateKey: this.storeKey,
                        criteria: this.overrideFilter,
                    });
                }

                await this.load_data();
            },
            async modifyCriteria(criteria) {
                if (this.targetPage) {
                    this.$store.commit('filters/update', {
                        criteriaPage: this.targetPage,
                        payload: criteria,
                    });
                }
                this.criteriaProps = criteria;
                await this.load_data();
            },
        },
        async created() {
            await this.init();
        },
        watch: {
            criteria: {
                deep: true,
                async handler(newVal, oldVal) {
                    let updatedNewVal = { ...newVal };

                    if (Object.keys(newVal.sort).length === 0){
                        updatedNewVal.sort = oldVal.sort;
                    }

                    const newStr = JSON.stringify(updatedNewVal);
                    const oldStr = JSON.stringify(oldVal);
                    if (newStr !== oldStr) {
                        await this.load_data(updatedNewVal);
                    }
                },
            },
        },
    };
</script>
